

























































































































































// Utils
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import numeral from 'numeral'
import moment from 'moment'
import { debounce } from 'lodash'
// Components
import ModalCoupon from '@/components/tables/ModalCoupon.vue'
import ModalCouponDelete from '@/components/tables/ModalCouponDelete.vue'
// Services
import Coupon from '@/services/Coupon'

@Component({
  components: { ModalCoupon, ModalCouponDelete },
  filters: {
    currency (value: number) { return numeral(value).format('0,0.00') }
  }
})
export default class CouponsRequest extends Vue {
  search = ''
  currentSearch = ''
  page = 1
  currentPage = 1
  totalPages = 1
  moment = moment
  coupons: any = []
  loader = true
  showDelete = false
  coupon: any = {
    showModal: false,
    update: false,
    type: '',
    couponSelected: { id: 0, name: '', state: '', phone: '', contact_email: '', discount: '', max_usage_times: '', expire_at: moment().format('DD-MM-YYYY') }
  }

  couponDelete: any = {
    showModal: false,
    update: false,
    name: ''
  }

  @Watch('page')
  updateCoupons () {
    this.loader = true
    this.getCoupons()
  }

  @Watch('coupon.update')
  updateCouponsCreateOrEdit () {
    if (!this.coupon.update) return
    this.loader = true
    this.getCoupons()
    this.coupon.update = false
  }

  @Watch('couponDelete.update')
  updateCouponsDelete () {
    if (!this.couponDelete.update) return
    this.loader = true
    this.search = ''
    this.getCoupons()
    this.couponDelete.update = false
  }

  searchNotary = debounce(async (search: string) => {
    await this.getCouponSearch(search)
  }, 500)

  async mounted () {
    this.prepareData()
  }

  async prepareData () {
    this.loading(true)
    try {
      await this.getCoupons()
      this.loading(false)
    } catch (error) {
      this.loading(false)
    }
  }

  async getCouponSearch (search: string) {
    this.search = search = search.trimStart()
    if (search === '' && this.currentSearch === '') {
      this.loader = false
      return
    }
    this.loader = true
    this.page = 1
    const [error, response] = await Coupon.getCouponsPaginated(this.page, '&search=' + search)
    if (error) {
      this.loader = false
      this.page = this.currentPage
      return this.$toasted.global.error(error)
    }
    this.currentPage = 1
    this.totalPages = response.data.data.last_page
    this.currentSearch = search
    this.coupons = response.data.data.data
    this.loader = false
  }

  async getCoupons () {
    const [error, response] = await Coupon.getCouponsPaginated(this.page, '&search=' + this.search)
    if (error) {
      this.loader = false
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    this.currentPage = this.page
    this.totalPages = response.data.data.last_page
    this.coupons = response.data.data.data
    this.loader = false
    this.loading(false)
  }

  openModal (action: string, data: any = null) {
    this.coupon.type = action
    if (this.coupon.type === 'create') {
      this.coupon.couponSelected.name = ''
      this.coupon.couponSelected.max_usage_times = ''
      this.coupon.couponSelected.discount = ''
      this.coupon.couponSelected.expire_at = moment().format('DD-MM-YYYY')
    } else {
      this.coupon.couponSelected.nameEditBackup = data.name
      this.coupon.couponSelected.name = data.name
      this.coupon.couponSelected.max_usage_times = data.max_usage_times
      this.coupon.couponSelected.discount = data.discount
      this.coupon.couponSelected.expire_at = moment.unix(data.expire_at).format('DD-MM-YYYY')
    }
    this.coupon.showModal = true
  }

  @Action('UPDATE_STATE_LOADING') loading: any
  @State('UserModule') state: any
}
